
<script setup>

  import { ref, onMounted, watch, watchEffect } from 'vue';

  import { useRouter } from 'vue-router';

  import { useRouteQuery } from '@vueuse/router';

  import zipCode from '../../state/zip-code';

  import Header from '../partials/header.vue';

  import Footer from '../partials/footer.vue';

  import mockupUrl from 'url:../../images/pop-health-data-mockup.png'; 

  const router = useRouter();

  const currentUrl = useRouteQuery( 'zip-code' );

  const form = ref( null );

  watchEffect( () => {
    
    zipCode.value = currentUrl.value;

    form.value?.setValues( { PM_Custom1: zipCode.value } );

  } );

  watch( form, form => {

    if ( ! form ) return;

    const formElm = form.getFormElem()[ 0 ];

    // Remove the form placeholder on ready.

    const wrapper = formElm.closest( '[ data-form-wrapper ]' );
    
    if ( wrapper ) wrapper.querySelector( '[ data-form-placeholder ]' )?.remove();

    // Position form rows containing a disclaimer to the bottom, above the submit button row.

    const buttonRow = formElm.querySelector( '.mktoButtonRow:has( button[ type = "submit" ] )' );

    const disclaimerRows = formElm.querySelectorAll( '.mktoFormRow:has( [ data-disclaimer ] )' );

    Array.from( disclaimerRows ).forEach( row => formElm.insertBefore( row, buttonRow ) );

    // Set the "referrer" form field.
    
    form.setValues( { referrer: document.referrer } );

    // Change submit button label.

    const submitButton = formElm.querySelector( '.mktoButton' );

    submitButton.innerText = 'Download Report';

    // Navigate to download on success.
    
    form.onSuccess( () => {
      
      router.push( { path: '/download', query: { 'zip-code': zipCode.value } } );

      return false;
    
    } );

  } );

  onMounted( () => {
    
    if ( typeof MktoForms2 == 'object' ) {

      MktoForms2.loadForm( 'https://info.biomerieux.com', '315-VKA-657', 3753 );
    
      MktoForms2.whenReady( reference => form.value = reference );

    }

  } );

</script>

<template>

  <Header />

  <main class="mb-0.25">

    <div class="
      
      pt-20 bg-blue-primary bg-no-repeat bg-[length:700px_auto] bg-[top_left_-345px]

      bg-[url(./images/circle-pattern-white.svg)]
      
      md:bg-[length:1000px_auto] md:bg-[left_-500px_center] sm:px-8 sm:pt-28 sm:pb-8 md:py-28 lg:px-24">

      <div class="max-w-6xl mx-auto">

        <div class="flex flex-col gap-14 md:flex-row">

          <div class="px-6 text-white sm:px-0 md:w-1/2 lg:w-3/5">

            <div class="max-w-xl">

              <span class="inline-block mb-8 px-4 py-[2px] font-bold text-green-bitter-lemon border-2 border-green-bitter-lemon">
                
                Custom Report
              
              </span>

              <h1 class="mb-5 text-2xl font-bold sm:mb-8 sm:text-[2.5rem] sm:leading-[1.25]">
                
                Community insights, ready when you are.
              
              </h1>

              <p class="mb-8 text-base sm:text-xl">

                Download your custom report to keep critical health trends at your fingertips.

              </p>

              <div class="flex justify-center">

                <img :src="mockupUrl" alt="bioMérieux Population Health Data Mockup" class="w-sm" />

              </div>

            </div>

          </div>

          <div id="form-container" class="md:w-1/2 lg:w-2/5">

            <div class="sm:rounded-xl overflow-hidden shadow-lg">

              <div class="py-8 bg-blue-prussian text-center sm:px-10 md:text-left">

                <h2 class="text-xl font-bold text-white sm:text-2xl xl:text-3xl">
                  
                  Download the Report
                
                </h2>

                <p class="text-lg font-normal text-green-rio sm:text-xl xl:text-2xl">

                  It's completely free.

                </p>

              </div>

              <div class="px-8 py-8 bg-white sm:px-10 sm:py-10 lg:px-10">

                <div data-form-wrapper class="grid">

                  <div data-form-placeholder class="row-start-1 col-start-1 flex items-center justify-center">

                    <svg viewBox="0 0 24 24" class="w-16 animate-spin" fill="none" aria-hidden="true">

                      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />

                      <path class="opacity-75" fill="currentColor"
                      
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />

                    </svg>

                  </div>

                  <div class="relative row-start-1 col-start-1">

                    <form id="mktoForm_3753"></form>

                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>
      
    </div>

  </main>

  <Footer />

</template>
